import type { ResolveDirectoryEntityType } from '@experiences/interfaces';
import { DirectoryEntryType } from '@experiences/interfaces';

export const MaxUsernameLength = 256;
export const MaxFirstNameLength = 64;
export const MaxLastNameLength = 64;
export const ReservedUsernames = [ 'ServiceAccount_08da82db-70b7-4' ];

export enum UserType {
    User,
    Robot,
    DirectoryUser,
    DirectoryGroup,
    RobotAccount,
    DirectoryApplication,
    DirectoryRobotUser,
}

export const USER_TYPE_ICON = {
    [UserType.User]: 'basic_auth_user',
    [UserType.Robot]: 'robot',
    [UserType.DirectoryUser]: 'directory_user',
    [UserType.DirectoryGroup]: 'directory_group',
    [UserType.RobotAccount]: 'robot',
    [UserType.DirectoryApplication]: 'directory_app',
    [UserType.DirectoryRobotUser]: 'robot',
};

export const DIRECTORY_TYPE_ICON = {
    [DirectoryEntryType.DirectoryUser as ResolveDirectoryEntityType]: 'directory_user',
    [DirectoryEntryType.DirectoryGroup as ResolveDirectoryEntityType]: 'directory_group',
    [DirectoryEntryType.LocalUser as ResolveDirectoryEntityType]: 'basic_auth_user',
    [DirectoryEntryType.LocalGroup as ResolveDirectoryEntityType]: 'basic_auth_group',
    [DirectoryEntryType.RobotAccount as ResolveDirectoryEntityType]: 'robot',
    [DirectoryEntryType.DirectoryApplication as ResolveDirectoryEntityType]: 'directory_app',
    [DirectoryEntryType.DirectoryRobotUser as ResolveDirectoryEntityType]: 'robot',
};

// TODO: filters
// export const USER_TYPE_LABEL = {
//     [UserType.User]: 'CLIENT_LOCAL_ACCOUNT',
//     [UserType.Robot]: 'CLIENT_ROBOT',
//     [UserType.DirectoryUser]: 'CLIENT_MANAGED_ACCOUNT',
//     [UserType.DirectoryGroup]: 'CLIENT_DIRECTORY_GROUP',
//     [UserType.RobotAccount]: 'CLIENT_ROBOT',
//     [UserType.DirectoryApplication]: 'CLIENT_DIRECTORY_APPLICATION',
// };
